import axios from 'axios';
import { apiKey, apiGetFileRules } from '../../config';

export const onRulesCall = async function(){
  let params = {
    apiKey: apiKey,
    token: sessionStorage.athenasToken
  }
  try {
    const response = await axios.get(apiGetFileRules, { params });
    //This response just returns the rules
    if(response.status === 200){
        return response.data;
    }else {
      alert("Something went wrong with getting the file upload rules.");
    }
  } catch(error){
    alert(error.response.data.Messages);
  }
}